module.exports = __webpack_public_path__ + "img/ic_nav_back.bf334e83.svg";